import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueI18n from 'vue-i18n';
import VuetifyConfirm from 'vuetify-confirm';

const vuetify = new Vuetify();

Vue.use(Vuetify);
Vue.use(VueI18n);
Vue.use(VuetifyConfirm, { vuetify });

export default vuetify;
